import { useMemo } from 'react';
import { useGetBenefits } from '@/common/integrations/menhir/employee/benefits/benefits.hooks';
import {
  IBenefit,
  IMenhirBenefitSlug,
} from '@/common/integrations/menhir/employee/benefits/benefits.types';

export function useBenefits(
  listFilter: (benefit: IBenefit) => boolean = () => true
) {
  const { benefits: allBenefits, isInitialLoading } = useGetBenefits();

  const benefits = useMemo(() => {
    const benefitsList = allBenefits
      ?.filter((benefit) => benefit.slug !== 'meals')
      .filter(listFilter);

    return benefitsList
      ? (benefitsList as IBenefit<IMenhirBenefitSlug>[])
      : undefined;
  }, [allBenefits, listFilter]);

  const mealProducts = useMemo(
    () => allBenefits?.find((benefit) => benefit.slug === 'meals')?.products,
    [allBenefits]
  );

  const benefitProducts = useMemo(
    () =>
      benefits
        ?.map((benefit) => benefit.products)
        .reduce((acc, current) => acc.concat(current), []),
    [benefits]
  );

  return {
    allBenefits,
    benefits,
    mealProducts,
    benefitProducts,
    loading: isInitialLoading,
  };
}
